import { render } from "./ComplementaryExamsSection.vue?vue&type=template&id=3fa302b4&scoped=true"
import script from "./ComplementaryExamsSection.vue?vue&type=script&lang=js"
export * from "./ComplementaryExamsSection.vue?vue&type=script&lang=js"

import "./ComplementaryExamsSection.vue?vue&type=style&index=0&id=3fa302b4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa302b4"]])

export default __exports__